import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { MakerService } from '../shared/maker.service';
import { AnalyticsService } from '../analytics/analytics.service';
import Chart from 'chart.js/auto';
import { ExperiencesService } from '../experiences/experiences/experiences.service';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss',
    '../../../../node_modules/keen-slider/keen-slider.min.css']
})
export class DashboardComponent implements OnInit {
  dashboardCardsIndex = 0

  title = 'Dashboard';
  activeFilter = 'months';

  directoryAnalytics: any;
  interactionChart: any;
  directoryChart: any;
  makerExperiences: any = [];
  publishedExperiences = 0;
  totalExperiences: any;
  makerContacts: any;
  totalContacts: any;
  makerGroups: any;
  totalGroups: any;
  maker: any;

  labelsArray = [];
  brandImpressionsArray = [];
  brandVisitsArray = [];
  productsImpressionsArray = [];
  shownDays = [
    { value: 0, text: 'Todos los días' },
    { value: 1, text: 'Lun' },
    { value: 2, text: 'Mar' },
    { value: 3, text: 'Mié' },
    { value: 4, text: 'Jue' },
    { value: 5, text: 'Vie' },
    { value: 6, text: 'Sáb' },
    { value: 7, text: 'Dom' },
  ];
  safeUrls = [];


  constructor(private experiencesService: ExperiencesService, private analyticsService: AnalyticsService, private makerService: MakerService, public translate: TranslateService, private sanitizer: DomSanitizer) { }

  ngOnInit(): void {
    this.analyticsService.getDirectoryAnalyticsByMakerId(this.makerService.getId()).subscribe(((resp: any) => {
      this.directoryAnalytics = resp['hydra:member'][0];
      this.createInteractionChart();
      this.createDirectoryChart();
    }))

    this.experiencesService.getAllExperiencesByMakerId(this.makerService.getId()).subscribe(((resp: any) => {
      resp['hydra:member'].forEach(experience => {
        if (experience.microsheetCompleted && experience.maker.directoryCompleted) {
          this.makerExperiences.push(experience);
        }
      });

      // console.log(this.makerExperiences)

      this.totalExperiences = resp['hydra:member'].length;

      this.makerExperiences.forEach(experience => {
        if (experience.isActive) {
          this.publishedExperiences++
        }
        this.safeUrls.push(this.sanitizer.bypassSecurityTrustResourceUrl('https://venntur.com/es/product/' + experience.slug));
      });
    }))

    this.makerService.getContactsByMakerId(this.makerService.getId()).subscribe(((resp: any) => {
      this.makerContacts = resp['hydra:member'];
      this.totalContacts = this.makerContacts.length;
    }))

    this.makerService.getContactsGroupsByMakerId(this.makerService.getId()).subscribe(((resp: any) => {
      this.makerGroups = resp['hydra:member'];
      this.totalGroups = this.makerGroups.length;
    }))

    this.makerService.getMaker('/makers/' + this.makerService.getId()).subscribe(((resp: any) => {
      this.maker = resp;
    }))
  }

  changeFilter(type: any) {
    this.activeFilter = type;
    this.interactionChart.destroy();
    this.directoryChart.destroy();
    this.createInteractionChart();
    this.createDirectoryChart();
  }

  createInteractionChart() {
    this.labelsArray = [];
    let dataArray = [];
    if (this.activeFilter == 'hours') {
      this.labelsArray = Array.from({ length: 24 }, (_, i) => (i < 10 ? '0' + i : i.toString()));
      this.labelsArray.forEach(hour => {
        dataArray.push(this.directoryAnalytics['calculateAnalyticsHour']['interactions'][hour] ? this.directoryAnalytics['calculateAnalyticsHour']['interactions'][hour] : 0);
      });
    } else if (this.activeFilter == 'days') {
      const today = new Date();

      for (let i = 0; i < 30; i++) {
        const currentDate = new Date(today);
        currentDate.setDate(today.getDate() - i);

        const year = currentDate.getFullYear();
        const month = String(currentDate.getMonth() + 1).padStart(2, '0');
        const day = String(currentDate.getDate()).padStart(2, '0');

        this.labelsArray.push(`${year}-${month}-${day}`);
      }

      this.labelsArray = this.labelsArray.reverse();

      this.labelsArray.forEach(day => {
        dataArray.push(this.directoryAnalytics['calculateAnalyticsDayMonth']['interactionsDays'][day] ? this.directoryAnalytics['calculateAnalyticsDayMonth']['interactionsDays'][day] : 0);
      });
    } else {
      const today = new Date();

      for (let i = 0; i < 12; i++) {
        const currentMonth = new Date(today);
        currentMonth.setMonth(today.getMonth() - i);

        const year = currentMonth.getFullYear();
        const month = String(currentMonth.getMonth() + 1).padStart(2, '0');

        this.labelsArray.push(`${year}-${month}`);
      }

      this.labelsArray = this.labelsArray.reverse();

      this.labelsArray.forEach(month => {
        dataArray.push(this.directoryAnalytics['calculateAnalyticsDayMonth']['interactionsMonths'].length > 0 ? this.directoryAnalytics['calculateAnalyticsDayMonth']['interactionsMonths'][month] : 0);
      });
    }

    setTimeout(() => {
      const data = {
        labels: this.labelsArray,
        datasets: [
          {
            label: 'Directorio',
            data: dataArray,
            borderColor: '#ff341f82',
            backgroundColor: '#ff341f82',
            pointStyle: 'circle',
            pointRadius: 5,
            pointHoverRadius: 8
          },
          {
            label: 'Totales',
            data: dataArray,
            borderColor: '#f9c64875',
            backgroundColor: '#f9c64875',
            pointStyle: 'circle',
            pointRadius: 5,
            pointHoverRadius: 8
          }
        ]
      };

      this.interactionChart = new Chart("interactionChart", {
        type: 'line', //this denotes tha type of chart

        data: data,
        options: {
          responsive: true,
          plugins: {
            title: {
              display: true,
              // text: (ctx) => 'Point Style: ' + ctx.chart.data.datasets[0].pointStyle,
            }
          }
        }

      });
    }, 500);
  }

  createDirectoryChart() {
    this.brandImpressionsArray = [];
    this.brandVisitsArray = [];
    this.productsImpressionsArray = [];

    // let labelsArray = [];
    if (this.activeFilter == 'hours') {
      // labelsArray = Array.from({ length: 24 }, (_, i) => (i < 10 ? '0' + i : i.toString()));

      this.labelsArray.forEach(hour => {
        this.brandImpressionsArray.push(this.directoryAnalytics['calculateAnalyticsHour']['directory']['brandImpressions'][hour] ? this.directoryAnalytics['calculateAnalyticsHour']['directory']['brandImpressions'][hour] : 0);
        this.brandVisitsArray.push(this.directoryAnalytics['calculateAnalyticsHour']['directory']['brandVisits'][hour] ? this.directoryAnalytics['calculateAnalyticsHour']['directory']['brandVisits'][hour] : 0);
        this.productsImpressionsArray.push(this.directoryAnalytics['calculateAnalyticsHour']['directory']['productsImpressions'][hour] ? this.directoryAnalytics['calculateAnalyticsHour']['directory']['productsImpressions'][hour] : 0);
      });
    } else if (this.activeFilter == 'days') {
      // const today = new Date();

      // for (let i = 0; i < 30; i++) {
      //   const currentDate = new Date(today);
      //   currentDate.setDate(today.getDate() - i);

      //   const year = currentDate.getFullYear();
      //   const month = String(currentDate.getMonth() + 1).padStart(2, '0');
      //   const day = String(currentDate.getDate()).padStart(2, '0');

      //   this.labelsArray.push(`${year}-${month}-${day}`);
      // }

      // this.labelsArray = labelsArray.reverse();

      this.labelsArray.forEach(day => {
        this.brandImpressionsArray.push(this.directoryAnalytics['calculateAnalyticsDayMonth']['directory']['brandImpressionsDays'][day] ? this.directoryAnalytics['calculateAnalyticsDayMonth']['directory']['brandImpressionsDays'][day] : 0);
        this.brandVisitsArray.push(this.directoryAnalytics['calculateAnalyticsDayMonth']['directory']['brandVisitsDays'][day] ? this.directoryAnalytics['calculateAnalyticsDayMonth']['directory']['brandVisitsDays'][day] : 0);
        this.productsImpressionsArray.push(this.directoryAnalytics['calculateAnalyticsDayMonth']['directory']['productsImpressionsDays'][day] ? this.directoryAnalytics['calculateAnalyticsDayMonth']['directory']['productsImpressionsDays'][day] : 0);
      });
    } else {
      // const today = new Date();

      // for (let i = 0; i < 12; i++) {
      //   const currentMonth = new Date(today);
      //   currentMonth.setMonth(today.getMonth() - i);

      //   const year = currentMonth.getFullYear();
      //   const month = String(currentMonth.getMonth() + 1).padStart(2, '0');

      //   labelsArray.push(`${year}-${month}`);
      // }

      // labelsArray = labelsArray.reverse();

      this.labelsArray.forEach(month => {

        if (this.directoryAnalytics['calculateAnalyticsDayMonth']['directory']['brandImpressionsMonths']) {
          this.brandImpressionsArray.push(this.directoryAnalytics['calculateAnalyticsDayMonth']['directory']['brandImpressionsMonths'][month]);
        } else {
          this.brandImpressionsArray.push(0);
        }

        if (this.directoryAnalytics['calculateAnalyticsDayMonth']['directory']['brandVisitsMonths']) {
          this.brandVisitsArray.push(this.directoryAnalytics['calculateAnalyticsDayMonth']['directory']['brandVisitsMonths'][month]);
        } else {
          this.brandVisitsArray.push(0);
        }


        // this.brandImpressionsArray.push(this.directoryAnalytics['calculateAnalyticsDayMonth']['directory']['brandImpressionsMonths'] ? this.directoryAnalytics['calculateAnalyticsDayMonth']['directory']['brandImpressionsMonths'][month] : 0);
        // this.brandVisitsArray.push(this.directoryAnalytics['calculateAnalyticsDayMonth']['directory']['brandVisitsMonths'][month] ? this.directoryAnalytics['calculateAnalyticsDayMonth']['directory']['brandVisitsMonths'][month] : 0);
        
        if (this.directoryAnalytics['calculateAnalyticsDayMonth']['directory']['productsImpressionsMonths']) {
          this.productsImpressionsArray.push(this.directoryAnalytics['calculateAnalyticsDayMonth']['directory']['productsImpressionsMonths'][month] ? this.directoryAnalytics['calculateAnalyticsDayMonth']['directory']['productsImpressionsMonths'][month] : 0);
        }
      });
    }

    setTimeout(() => {
      const data = {
        labels: this.labelsArray,
        datasets: [
          {
            label: 'Impresiones de marca',
            data: this.brandImpressionsArray,
            borderColor: '#ff341f82',
            backgroundColor: '#ff341f82',
            pointStyle: 'circle',
            pointRadius: 5,
            pointHoverRadius: 8
          },
          {
            label: 'Visitas ficha maker',
            data: this.brandVisitsArray,
            borderColor: '#f9c64875',
            backgroundColor: '#f9c64875',
            pointStyle: 'circle',
            pointRadius: 5,
            pointHoverRadius: 8
          },
          {
            label: 'Impresiones de productos',
            data: this.productsImpressionsArray,
            borderColor: '#e5408f7d',
            backgroundColor: '#e5408f7d',
            pointStyle: 'circle',
            pointRadius: 5,
            pointHoverRadius: 8
          }
          // {
          //   label: 'Visitas ficha productos',
          //   data: [0, 1, 2, 1, 2, 3, 1, 3, 2, 0, 1, 2, 1, 2, 3, 1, 3, 2, 0, 1, 2, 1, 2, 3, 1, 3],
          //   borderColor: '#0867ff80',
          //   backgroundColor: '#0867ff80',
          //   pointStyle: 'circle',
          //   pointRadius: 5,
          //   pointHoverRadius: 8
          // }
        ]
      };

      this.directoryChart = new Chart("directoryChart", {
        type: 'line', //this denotes tha type of chart

        data: data,
        options: {
          responsive: true,
          plugins: {
            title: {
              display: true,
              // text: (ctx) => 'Point Style: ' + ctx.chart.data.datasets[0].pointStyle,
            }
          }
        }

      });
    }, 500);
  }

  setCategoryTitle(experience) {
    return experience.categories.map(obj => obj.name).join(' / ')
  }

  setLanguagesTitle(experience) {
    return experience.languages.map(obj => obj.name).join(' , ')
  }

  convertTimeToCustomFormat(inputTime: string): string {
    let formattedText;
    const [hours, minutes] = inputTime.split(':').map(part => parseInt(part, 10));

    if (minutes != 0) {
      formattedText = hours + ' h y ' + minutes + ' min'
    } else {
      formattedText = hours + ' h'
    }

    return formattedText;
  }

}
